import { Typography } from "antd";
import "./DateDisplay.css";
import dayjs from "dayjs";

export const EventDateDisaply = ({ start, end }) => {
  const startTime = dayjs(start),
    endTime = dayjs(end);

  return (
    <DateDisplay
      date={startTime.format("MMM Do")}
      time={startTime.format("h:mma")}
      end={endTime.format("h:mma")}
    />
  );
};

const DateDisplay = ({ date, time, end }) => {
  return (
    <div className="carisity-date-display">
      <div className="title">{date}</div>
      <div className="content">
        <p>{time}</p>
        {end}
      </div>
    </div>
  );
};

export const DateDisplaySimple = ({ date, time, end }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <Typography.Paragraph>{date}</Typography.Paragraph>
      <Typography.Paragraph>
        {time} - {end}
      </Typography.Paragraph>
    </div>
  );
};

export default DateDisplay;
